<div class="fn-card-transactions__container">
  <div class="fn-card-transactions__container-table">
    <app-fn-tables
      [optionalTitle]="'IP.TABLE.CARD-TRANSACTIONS.TITLE'"
      [tableOption]="tableOptions"
      [propertyOrder]="propertyOrder"
      [pageItems]="10"
      [filter]="false"
      [supplierId]="this.selectedSupplierId"
      service="card-transactions"
    />
  </div>
</div>
